import React, { useMemo } from 'react';
import { ResponsiveBar } from '@nivo/bar';
import { useChartCreditDebitMonthly } from '../../../hooks/useChartData';
import ChartCard from '../wrappers/ChartCard';
import nivoCustomTheme from '../theme/nivoCustomTheme';
import useResponsive from '../../../hooks/useResponsive';

const formatCLP = (v) => `$${Math.round(v).toLocaleString('es-CL')}`;

export default function CreditDebitBarChart({ dateFrom, dateTo, categoryIds }) {
  const { isMobile } = useResponsive();
  const { data, loading, error } = useChartCreditDebitMonthly({ dateFrom, dateTo, categoryIds });

  const chartData = useMemo(
    () => data?.chartCreditDebitMonthly ?? [],
    [data]
  );

  return (
    <ChartCard
      title="Crédito vs Débito por Mes"
      subtitle="Volumen mensual de ingresos y egresos"
      loading={loading && !data}
      error={error}
      height={320}
    >
      <ResponsiveBar
        data={chartData}
        keys={['credit', 'debit']}
        indexBy="month"
        groupMode="grouped"
        colors={['#FFD60A', '#26619C']}
        theme={nivoCustomTheme}
        margin={isMobile
          ? { top: 10, right: 20, bottom: 80, left: 50 }
          : { top: 10, right: 120, bottom: 60, left: 80 }
        }
        padding={0.25}
        innerPadding={3}
        axisBottom={{
          tickSize: 0,
          tickPadding: 8,
          tickRotation: -30,
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 8,
          format: (v) => `$${(v / 1000).toFixed(0)}k`,
        }}
        enableGridY={true}
        enableGridX={false}
        enableLabel={false}
        tooltip={({ id, value, indexValue }) => (
          <div style={{ background: '#fff', padding: '8px 12px', borderRadius: 8, border: '1px solid #F0F0F0', boxShadow: '0 4px 20px rgba(38,97,156,0.12)', fontSize: 12, fontFamily: '"Inter", sans-serif' }}>
            <div style={{ fontWeight: 600, marginBottom: 4 }}>{indexValue}</div>
            <div>{id === 'credit' ? 'Crédito' : 'Débito'}: {formatCLP(value)}</div>
          </div>
        )}
        legends={[{
          dataFrom: 'keys',
          anchor: isMobile ? 'bottom' : 'right',
          direction: isMobile ? 'row' : 'column',
          translateY: isMobile ? 70 : 0,
          itemWidth: 100,
          itemHeight: 18,
          itemsSpacing: isMobile ? 16 : 4,
          symbolSize: 10,
          symbolShape: 'circle',
          data: [
            { id: 'credit', label: 'Crédito', color: '#FFD60A' },
            { id: 'debit',  label: 'Débito',  color: '#26619C' },
          ],
        }]}
        animate={true}
        motionConfig="gentle"
      />
    </ChartCard>
  );
}
